import ShiftingBidsTable from './ShiftingBidsTable';

export default ShiftingBidsTable;
